module.exports = __webpack_public_path__ + "img/古灵女.9c737727.png";